import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RouteComponentProps } from "react-router-dom";

import isContentfulPreview from "utils/isContentfulPreview";
import get from "lodash/get";

import { initializeApplication } from "state/actions/applicationActions";
import { closeMiniCart } from "state/actions/ui/miniCartUIactions";
import { fetchCheckout } from "state/actions/checkoutActions";

import Nav from "components/Nav";
import Routes from "routes";
import Footer from "components/Footer";
import MiniCart from "components/MiniCart";
import ErrorPage from "components/ErrorPage";

import { GlobalState, Status } from "types";
import { CheckoutReducer } from "state/reducers/checkout";

import "what-input";
import "styles/App.scss";

interface OwnProps {
  initializeApplicationStatus: Status;
  actions: {
    initializeApplication(checkoutId: string, isPreview: boolean): void;
    closeMiniCart(): void;
    fetchCheckout(checkoutId: string): void;
  };
  checkout: CheckoutReducer;
}

type Props = OwnProps & RouteComponentProps;

class App extends Component<Props> {
  constructor(props: Props) {
    super(props);

    const { initializeApplicationStatus, actions, checkout } = props;
    const checkoutId = get(checkout, "checkout.id", "");
    const isPreview = isContentfulPreview();

    if (initializeApplicationStatus === Status.IDLE) {
      actions.initializeApplication(checkoutId, isPreview);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { initializeApplicationStatus, actions } = this.props;
    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.scrollTo(0, 0);
      this.props.actions.closeMiniCart();
    }

    if (
      prevProps.initializeApplicationStatus === Status.PENDING &&
      initializeApplicationStatus === Status.FULFILLED
    ) {
      setInterval(() => {
        return actions.fetchCheckout(this.props.checkout.checkout.id);
      }, 180000);
    }
  }

  render() {
    const { location } = this.props;

    if (this.props.initializeApplicationStatus === Status.REJECTED) {
      return (
        <ErrorPage
          errorTitle="Something went wrong"
          errorMessage="Our online shop is currently unavailable. Refresh the page or try again later."
          buttonLabel="Refresh"
          buttonOnClick={() => window.location.reload()}
        />
      );
    }

    if (this.props.initializeApplicationStatus === Status.FULFILLED) {
      return (
        <div className="App relative bg-color-gray-lighter flex flex-col">
          <div className="App__border-y fixed l0 r0 t0 z-overlay bg-color-white" />
          <div className="App__border-x fixed t0 b0 r0 z-overlay bg-color-white" />
          <div className="App__border-y fixed l0 r0 b0 z-overlay bg-color-white" />
          <div className="App__border-x fixed t0 b0 l0 z-overlay bg-color-white" />
          <Nav />
          <div className="App__main-container flex-grow">
            <Routes location={location} />
          </div>
          <Footer location={location} />
          <MiniCart />
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state: GlobalState) => ({
  initializeApplicationStatus: state.status.initializeApplication,
  checkout: state.session.checkout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      initializeApplication,
      closeMiniCart,
      fetchCheckout
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
